module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("There were two members of my family who unconditionally supported me during the writing of this book. Their complete attentiveness and devotion never wavered, and I would like to say how grateful I was for their efforts to keep me warm in the conservatory during the long winter evenings.")]), _vm._v(" "), _c('p', [_vm._v("Lying across my feet really did work!")]), _vm._v(" "), _c('p', [_vm._v("Max and Teddy, thank you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1d7b040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch005.vue
// module id = 75
// module chunks = 0